import { useAtomValue, useSetAtom } from "jotai";

import type { ArrayField, Field, ItemAtom } from "../../lib/form";

export type UseArrayField<TItem extends Field, TValue> = {
  items: TItem[];
  itemAtoms: ItemAtom[];
  append: (value: TValue) => void;
  insert: (value: TValue, before?: ItemAtom) => void;
  remove: (itemAtom: ItemAtom) => void;
  isEmpty: boolean;
  count: number;
};

export function useArrayField<TItem extends Field, TValue>(
  field: ArrayField<TItem, TValue>,
): UseArrayField<TItem, TValue> {
  const items = useAtomValue(field.itemsAtom);
  const itemAtoms = useAtomValue(field.itemAtomsAtom);
  const insert = useSetAtom(field.insert);
  const remove = useSetAtom(field.remove);

  return {
    items,
    itemAtoms,
    append: (value: TValue) => insert({ value }),
    insert: (value: TValue, before?: ItemAtom) => insert({ value, before }),
    remove: (itemAtom: ItemAtom) => remove(itemAtom),
    isEmpty: 0 === items.length,
    count: items.length,
  };
}
